@if (sharedPolicyData) {
  <div class="cds-p-[10px]">
    <div class="custom-tab-group">
      <div class="cds-flex cds-overflow-x-auto">
        @for (tab of customerTabs; track tab) {
          <div
            class="cds-py-3 cds-px-5 cds-flex-1 cds-cursor-pointer cds-text-center cds-font-bold hover:cds-bg-[#e0e0e0] cds-transition-colors cds-duration-200"
            [class]="
              selectedTab === tab
                ? 'cds-bg-white cds-border-t-2 cds-border-purple cds-border-solid'
                : 'cds-bg-neutral-100'
            "
            (click)="selectTab(tab)">
            <p data-testid="customer-tab-name">
              {{ sharedPolicyData.customers![_getCustomerIndex(tab)].firstName }}
              {{ sharedPolicyData.customers![_getCustomerIndex(tab)].lastName }}
              @if (_showCustomerErrors(_getCustomerIndex(tab)).length > 0) {
                <span class="cds-text-red-700 cds-font-bold cds-ml-1">*</span>
              }
            </p>
          </div>
        }
      </div>

      <div class="cds-flex cds-flex-col cds-w-full cds-p-3">
        @for (tab of customerTabs; track tab) {
          @if (selectedTab === tab) {
            <app-personal-details
              [customer]="customer"
              [dobError]="hasDobError"
              [genderValue]="genderVal"
              [smokerValue]="smokerVal"/>
            <app-coverage-details
              [customerIndex]="_getCustomerIndex(tab)"
              [coverages]="coverages"
              [customers]="customers"
              [initialOpenAccordions]="getOpenCoverageAccordions(tab)"
              [coverageErrors]="coverageErrors"/>
          }
        }
      </div>
    </div>
  </div>
}
